export default __webpack_public_path__ + "static/media/land_type_mountain.06c220e9.jpg";